import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import MaterialTable from 'material-table';
import { Container } from '@material-ui/core';
import React, { useEffect, useState, useRef } from 'react';

import Edit from './Components/Edit.js'
import api from '../../../../services/api.js';

export default function MyTable(props) {
    const tableRef = useRef();
    const snack = useRef()
    const { enqueueSnackbar } = useSnackbar();
    snack.current = enqueueSnackbar

    const [info, setInfo] = useState([]);

    const state = {
        columns: [
            {
                title: "Opções", field: "opcoes", cellStyle: { width: '5%', textAlign: "center", },
                render: (rowData) => {
                    return (
                        <Edit setData={props.setData} setOpen={props.setOpen} data={rowData} />
                    )
                }
            },
            { title: "Função", field: "funcao" },
            {
                title: " Usina",
                render: (rowData) => {
                    return (
                        <>
                            {rowData.usina_atuacao.map(txt => <p>{txt}</p>)}
                        </>
                    )
                }
            },
            { title: "Em exercício", field: "exercicio" },
            {
                title: "Responsáveis",
                render: (rowData) => {
                    return (
                        <>
                            {rowData.responsaveis.map(txt => <p>{txt}</p>)}
                        </>
                    )
                }
            },
        ],
    };

    useEffect(() => {
        async function fetchData() {
            api.get(`/funcoes`)
                .then((res) => {
                    let table = []
                    for (let doc of res.data) {
                        let usina_atuacao = []
                        for (let usina of doc.usinas) {
                            usina_atuacao.push(usina.nome)
                        }
                        doc["usina_atuacao"] = usina_atuacao
                        doc["idFuncao"] = doc._id
                        doc["exercicio"] = doc.exercicio ? doc.exercicio.nome : ""
                        table.push(doc)
                    }
                    setInfo(table)
                })
                .catch((error) => {
                    console.log(error);
                    snack.current("Falha ao buscar funções", { variant: 'error' })
                });
        }
        fetchData();
    }, [props.reload]);

    return (
        <Container maxWidth={false} spacing={2}>
            <MaterialTable
                tableRef={tableRef}
                title="Funções"
                columns={state.columns}
                data={info}
                options={{
                    search: true,
                    pageSize: 10,
                    exportButton: false,
                    emptyRowsWhenPaging: false,
                    pageSizeOptions: [1, 5, 10, 15, 20],
                    padding: "dense",
                    headerStyle: {
                        textAlign: "center",
                        color: "#b31b1b",
                    },
                    cellStyle: {
                        textAlign: "center",
                    },
                }}

                localization={{
                    body: {
                        emptyDataSourceMessage: "",
                        addTooltip: "adicionar novo",
                        deleteTooltip: "excluir",
                        editRow: { deleteText: "Deseja excluir?" },
                    },

                    header: {
                        actions: "Opções",
                    },

                    toolbar: {
                        searchTooltip: "Pesquisar",
                        searchPlaceholder: "Pesquisar",
                        exportTitle: "exportar",
                        nRowsSelected: "{0} Usuários(s) selecionados",
                    },
                    pagination: {
                        labelRowsSelect: "",
                        labelDisplayedRows: "{count} de {from}-{to}",
                        firstTooltip: "Primeira página",
                        previousTooltip: "Página anterior",
                        nextTooltip: "Próxima página",
                        lastTooltip: "Última página",
                    },
                }}
            />
        </Container >
    );
}

MyTable.propTypes = {
    reload: PropTypes.bool,
    setData: PropTypes.func,
    setOpen: PropTypes.func,
    setReload: PropTypes.func,
    setAffiliates: PropTypes.func,
};
